import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_FIELDS
} from './constants';
import { REPORT_TO } from '../StepOther/constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    repatriationBenefitItems: [],
    repatriationItems: [],
    returnHomeBenefitItems: [],
    deathRemainsItems: [],
    deathBurialItems: [],
    deathTransportItems: [],
  },
  errors: [],
});


function handleFormReset(state, { fields }) {
  // Only reset the specified fields to empty arrays or default values
  let newState = state;
  fields.forEach(field => {
    // Get the default value from initialState for this field
    const defaultValue = initialState.getIn(['form', field]);
    // Reset the field to its default value (empty array [] or empty string '')
    newState = newState.setIn(['form', field], defaultValue);
  });
  
  return newState;
}

function stepOtherTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_FIELDS:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default stepOtherTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/reducer.js